module.exports = __webpack_public_path__ + "img/home-map-location_jp.7cfecc06.jpg";